import React from 'react';
import { Drawer, Checkbox, Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import './styleFilteredOwnerModal.css';

interface FilteredOwnerModalProps {
    visible: boolean;
    onClose: () => void;
    selectedTypes: string[];
    onTypeChange: (types: string[]) => void;
    availableTypes: { label: string; value: string }[];
}

const FilteredOwnerModal: React.FC<FilteredOwnerModalProps> = ({
    visible,
    onClose,
    selectedTypes,
    onTypeChange,
    availableTypes,
}) => {
    return (
        <Drawer
            title={<span style={{ fontWeight: 400, fontSize: 24, }}>
                <CloseOutlined
                    className="closeBut"
                    onClick={onClose}
                    style={{
                        marginLeft: 'auto',
                        cursor: 'pointer',
                    }}
                />
                Фильтр</span>}
            placement="right"
            onClose={onClose}
            open={visible}
            width={400}
            className="filtered-owner-modal"
            footer={
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button className="buttonModalSetting" onClick={onClose}>
                        Сохранить
                    </Button>
                </div>
            }
        >
            <div className="filter-section">
                <div className="filter-label">Тип</div>
                <Checkbox.Group
                    options={availableTypes}
                    value={selectedTypes}
                    onChange={onTypeChange}
                    style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
                />
            </div>
        </Drawer>
    );
};

export default FilteredOwnerModal;
